<style lang="scss" scoped>
    .species-view {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &__content {
            flex: 1 0 100%;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding: 50px;

            @include above(md) {
                flex-wrap: nowrap;
                padding: 0 125px;
                align-items: center;
            }
        }

        &__remark {
            display: flex;
            align-items: center;

            @include above(md) {
                flex: 0 0 auto;
                max-width: 400px;
            }
        }

        &__species-container {
            flex: 1 1 100%;
            display: flex;
            flex-wrap: wrap;
            @include above(md) {
                flex-wrap: nowrap;
            }
            & > div {
                flex: 1 1 100%;
                display: flex;

                @include above(md) {
                    flex: 1 1 50%;
                }
            }
        }
    }
</style>
<template>
    <main class="species-view">
        <div class="species-view__content">
            <remark class="species-view__remark" key="remark" copy="Explore Genomic Cytometry by choosing a model." />
            <div class="species-view__species-container">
                <div v-for="s in species" :key="s.key">
                    <species @show-crowdsource="setCrowdsourceActive(true)" :attract-attention="s.key === 'human'" :species="s" :showName="true" />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import Remark from '@/components/Remark'
import Species from '@/components/Species'
import { mapState, mapActions, mapMutations } from 'vuex'
import TitleMixin from '@/mixins/title-mixin'

export default {
    mixins: [TitleMixin],
    name: 'SpeciesView',
    computed: {
        ...mapState([
            'species',
        ]),
    },
    methods: {
        ...mapActions([
            'getSpecies',
        ]),
        ...mapMutations([
            'setCrowdsourceActive',
        ]),
    },
    async mounted() {
        await this.getSpecies()
    },
    components: {
        Remark,
        Species,
    },
}
</script>
